import { DEFAULT_ROLE_FILTER } from 'constants/common'
import RoleTypes from 'store/actionTypes/role'
import UserTypes from 'store/actionTypes/user'

const initialData = {
  list: [],
  current: {},
  pagination: {},
  permissions: [],
  groups: [],
  systems: [],
  filter: DEFAULT_ROLE_FILTER
}

const role = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case RoleTypes.GET_ROLES_SUCCESS:
      return {
        ...state,
        list: payload?.items,
        pagination: payload?.meta
      }
    case RoleTypes.GET_GROUPS_SUCCESS:
      return {
        ...state,
        groups: payload?.items
      }
    case RoleTypes.GET_PERMISSIONS_SUCCESS:
      return { ...state, permissions: payload }
    case RoleTypes.GET_ROLE_DETAIL_SUCCESS:
      return { ...state, current: payload }
    case RoleTypes.UPDATE_FILTER_ROLE_SUCCESS:
      return { ...state, filter: payload }
    case RoleTypes.CLEAR_FILTER_ROLE_SUCCESS:
      return { ...state, filter: initialData.filter }
    case RoleTypes.GET_SYSTEM_ROLES_SUCCESS:
      return { ...state, systems: payload?.items }
    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    default:
      return state
  }
}

export default role
